import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {searchListPackagedItems} from "../../services/api/apiNextBox"
import timeHumanize from "../helpers/timeHumanize"


class ItemPackageStatus extends Component {
    state = {
        item: {}
    }

    componentDidMount() {
        this._fetchPackageStatus()
    }

    _fetchPackageStatus = async () => {
        const {barcodeNumber} = this.props

        try {
            const barcode = `#${barcodeNumber}_1`
            const {success, data} = await searchListPackagedItems({barcode})
            if (!success) return

            const {items} = Object.assign({}, data)
            if (!items || !items.length) return false


            const firstItem = items[0]
            this.setState({
                item: firstItem
            })
        } catch (e) {

        }
    }

    render() {
        const {item} = this.state
        const {status, created, box} = Object.assign({}, item)
        if (status !== 'packaged') return false

        const {id} = Object.assign({}, box)

        return (
            <div className="ItemPackageStatus">
                <strong>Đóng gói: </strong>
                <span>{timeHumanize(created)}</span>

                {!!id &&
                <div className="Box">Thùng: #{id}</div>
                }
            </div>
        )
    }
}

ItemPackageStatus.propTypes = {
    barcodeNumber: PropTypes.any,
}

export default ItemPackageStatus
